import { render } from "./RenameFlowModal.vue?vue&type=template&id=48cd25a6"
import script from "./RenameFlowModal.vue?vue&type=script&lang=js"
export * from "./RenameFlowModal.vue?vue&type=script&lang=js"
script.render = render

export default script